import React from 'react';
import PropTypes from 'prop-types';
import IconButton from './IconButton';
import _ from 'lodash';

import {
  formatPhoneNumber,
  getSmsLink,
  getPhoneLink,
  getEmailLink
} from 'helpers/utilities';

const DetailField = ({ label, children, className }) => {
  DetailField.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
      PropTypes.string
    ])
  };

  return (
    <div className={`mb-3 ${className}`}>
      <div>
        <strong>
          {label}
        </strong>
      </div>
      {children}
    </div>
  );
};

const Details = ({ ...props }) => {
  Details.propTypes = {
    activeReferral: PropTypes.object.isRequired
  };

  const contact = props.activeReferral;

  return (
    <div
      className='mt-4 js-contact-details container-fluid card-back '
      style={{ display: 'block' }}
    >
      <div className='d-flex justify-content-between align-items-center'>
        <h4>Contact Details</h4>
      </div>
      <div className='contact-details-wrapper'>
        <div className='row'>
          <div className='col-md-6'>
            <DetailField label='Phone' className='small-sm-down'>
              {
                _.get(contact, 'phoneNumbers') && contact.phoneNumbers.map(phone => (
                  <div
                    key={phone.phoneNumberKey}
                    className='d-flex justify-content-between align-items-center'
                  >
                    <div>
                      <span>{ phone.phoneNumberType }</span> { formatPhoneNumber(phone.phoneNumber) }
                    </div>
                    <div className='d-flex align-items-center'>
                      <div>{ phone.isPrimary && 'Primary'}</div>
                      { phone.phoneNumberType === 'Mobile'
                        ? <IconButton
                          iconName='material-icons material-icons-chat-bubble-outline'
                          iconSize='h3'
                          textColor='text-primary'
                          styles='ml-2 mr-2 p-0'
                          link={getSmsLink(phone.phoneNumber)}
                        />
                        : null
                      }
                      <IconButton
                        iconName='material-icons material-icons-phone'
                        iconSize='h3'
                        textColor='text-primary'
                        styles='m-0 p-0 ml-2'
                        link={getPhoneLink(phone.phoneNumber)}
                      />
                    </div>
                  </div>
                ))
              }
            </DetailField>

            <DetailField label='Email' className='small-sm-down'>
              {
                _.get(contact, 'emailAddresses') && contact.emailAddresses.map(email => (
                  <div
                    key={email.emailAddressKey}
                    className='d-flex justify-content-between align-items-center'
                  >
                    <a
                      href={getEmailLink(email.emailAddress)}
                      className='text-primary m-0 p-0'
                      target='_blank'
                      style={{ wordBreak: 'break-all' }}
                    >
                      {email.emailAddress}
                    </a>
                    <div>
                      {
                        email.emailType
                      }
                    </div>
                  </div>
                ))
              }
            </DetailField>

            <DetailField label='Address' className='small-sm-down'>
              {
                _.get(contact, 'addresses') && contact.addresses.map(address => (
                  <div
                    key={address.addressKey}
                    className='mb-3'
                  >
                    <div className='d-flex justify-content-between align-items-center'>
                      <div className='m-0 p-0'>
                        { address && address.address1 }
                      </div>
                      <div className='d-flex align-items-center'>
                        { address && address.addressType }
                      </div>
                    </div>
                    <div>
                      { `${address && address.city}, ${address && address.stateOrProvince} ${address && address.postalCode}` }
                    </div>
                  </div>
                ))
              }
            </DetailField>
          </div>
          <div className='col-md-6'>
            <DetailField label='Source' className='small-sm-down'>
              { _.get(contact, 'leadSources[0].leadSource') } / { _.get(contact, 'leadSources[0].subLeadSource') }
            </DetailField>
            <DetailField label='Company' className='small-sm-down'>
              { _.get(contact, 'company') }
            </DetailField>

            <DetailField label='Occupation' className='small-sm-down'>
              { _.get(contact, 'jobTitle') }
            </DetailField>

            <DetailField label='Nickname' className='small-sm-down'>
              { _.get(contact, 'nickname') }
            </DetailField>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
